// extracted by mini-css-extract-plugin
export default {"poster":"poster__4GrwJ","popover":"popover__2mLJb"};